import createIcon from '../../createIcon';

/**
 * @component @name SwitchAccessShortcut
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC4wNiA4Ljk0TDYgOEw4LjA2IDcuMDZMOSA1TDkuOTQgNy4wNkwxMiA4TDkuOTQgOC45NEw5IDExTDguMDYgOC45NFpNOSAyMUw5Ljk0IDE4Ljk0TDEyIDE4TDkuOTQgMTcuMDZMOSAxNUw4LjA2IDE3LjA2TDYgMThMOC4wNiAxOC45NEw5IDIxWk01LjM3IDEyLjM3TDQgMTNMNS4zNyAxMy42M0w2IDE1TDYuNjMgMTMuNjNMOCAxM0w2LjYzIDEyLjM3TDYgMTFMNS4zNyAxMi4zN1pNMTMgMTJDMTMgOS4yNyAxNC4wOCA2LjczIDE1Ljc1IDQuNzVMMTMgMkgyMFY5TDE3LjE4IDYuMThDMTUuODQgNy44MiAxNSA5Ljg4IDE1IDEyQzE1IDE1LjMyIDE3LjEgMTguMzYgMjAgMTkuODJWMjJDMTUuOTEgMjAuNDEgMTMgMTYuMzUgMTMgMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwitchAccessShortcut = createIcon('SwitchAccessShortcut', [
  [
    'path',
    {
      d: 'M8.06 8.94L6 8L8.06 7.06L9 5L9.94 7.06L12 8L9.94 8.94L9 11L8.06 8.94ZM9 21L9.94 18.94L12 18L9.94 17.06L9 15L8.06 17.06L6 18L8.06 18.94L9 21ZM5.37 12.37L4 13L5.37 13.63L6 15L6.63 13.63L8 13L6.63 12.37L6 11L5.37 12.37ZM13 12C13 9.27 14.08 6.73 15.75 4.75L13 2H20V9L17.18 6.18C15.84 7.82 15 9.88 15 12C15 15.32 17.1 18.36 20 19.82V22C15.91 20.41 13 16.35 13 12Z',
      key: '3t5a3s',
    },
  ],
]);

export default SwitchAccessShortcut;
